"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSPreloadScene = void 0;
const KHPreloadScene_1 = require("./KH/KHPreloadScene");
class TSPreloadScene extends KHPreloadScene_1.KHPreloadScene {
    constructor() {
        super("TSPreloadScene");
    }
    nextScene() {
        return "TSMediatingScene";
    }
    palette() {
        return [0x5f361b, 0xea4f0d, 0xd9c9ba];
    }
    loadAssets() {
        super.loadAssets();
        this.load.bitmapFont('font', 'assets/small.png', 'assets/small.fnt');
        this.load.image('block', 'assets/grid_item.png');
        this.load.image('select', 'assets/select2.png');
        this.load.image('board', 'assets/wood.png');
        this.load.image('table', 'assets/table.png');
        this.load.image('box', 'assets/logo.png');
        this.load.image('certificate', 'assets/certificate.png');
        // this.load.image('controls', 'assets/controls.png')
        this.load.image('paper', 'assets/paper.png');
        this.load.image('h2p', 'assets/h2p.png');
        this.load.image('controls', 'assets/paper_rules.png');
        // this.load.image('paper_box', 'assets/level_box.png')
        // this.load.image('paper_box_l', 'assets/level_box_win.png')
        // this.load.image('paper_box_w', 'assets/level_box_success.png')
        for (let i = 1; i <= 6; i++) {
            this.load.audio(`move${i}`, `assets/move${i}.wav`);
        }
        this.load.audio('move_bad1', 'assets/move_bad1.wav');
        this.load.audio('move_bad2', 'assets/move_bad2.wav');
        this.load.audio('move_death', 'assets/move_death.wav');
        this.load.audio('bg_audio', 'assets/bg.mp3');
        this.load.audio('lose', 'assets/lose.wav');
        this.load.audio('deal', 'assets/deal.wav');
        this.load.audio('win', 'assets/win.wav');
        this.load.audio('paper_slide', 'assets/paper_slide.wav');
        this.load.audio('paper_slide2', 'assets/paper_slide2.wav');
        this.load.audio('wood_slide', 'assets/wood_slide.wav');
        this.load.audio('box_slide', 'assets/box_slide.wav');
        this.scene.run("KHInputScene");
    }
}
exports.TSPreloadScene = TSPreloadScene;
